"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AddressDetails = /** @class */ (function (_super) {
    __extends(AddressDetails, _super);
    function AddressDetails() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddressDetails.prototype.render = function () {
        var address = this.props.address;
        return (React.createElement("div", { className: this.props.className }, address ? (React.createElement("div", null,
            address.name ? (React.createElement("span", null,
                address.name,
                React.createElement("hr", null))) : null,
            this.props.birthday ? React.createElement("span", null, this.props.birthday) : null,
            React.createElement("span", null,
                address.email,
                React.createElement("hr", { className: "mb-1-6" })),
            address.address1 ? (React.createElement("span", null,
                address.address1,
                React.createElement("hr", null))) : null,
            React.createElement("span", null, (address.city ? address.city : null) + ", " + (address.province ? address.province : null) + ", " + (address.zip ? address.zip : null),
                React.createElement("hr", null)),
            address.country ? (React.createElement("span", null,
                address.country,
                React.createElement("hr", null))) : null,
            address.phone ? (React.createElement("span", null,
                address.phone,
                React.createElement("hr", null))) : null)) : ([])));
    };
    return AddressDetails;
}(React.PureComponent));
exports.AddressDetails = AddressDetails;
